
import React, { useState } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { API } from '../../utils/api';

export function AdminLogin({ onLogin }) {
  const [form, setForm] = useState({ username: '', password: '' });
  
  const handleLogin = async () => {
    try {
      const res = await axios.post(`${API}/admin/login`, form);
      localStorage.setItem('admin_token', res.data.token);
      localStorage.setItem('admin_user', JSON.stringify(res.data.admin));
      onLogin(res.data.token, res.data.admin);
      toast.success('Admin login successful');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Login failed');
    }
  };
  
  return (
    <div className="min-h-screen bg-green-50 flex items-center justify-center">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Super Admin Login (V7.21)</CardTitle>
          <CardDescription>Vendor Registry Management</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <div>
            <Label>Username</Label>
            <Input 
              data-testid="admin-username-input"
              value={form.username} 
              onChange={(e) => setForm({...form, username: e.target.value})}
            />
          </div>
          <div>
            <Label>Password</Label>
            <Input 
              data-testid="admin-password-input"
              type="password"
              value={form.password} 
              onChange={(e) => setForm({...form, password: e.target.value})}
            />
          </div>
          <Button className="w-full" onClick={handleLogin} data-testid="admin-login-btn">Login</Button>
        </CardContent>
      </Card>
      <Toaster richColors />
    </div>
  );
}
